import React from 'react'
import PropTypes from 'prop-types'
import { ExperimentsProvider } from '@maui-mf/experiments'
import { MauiMfSplitFactory } from '@maui-mf/splitio-react'
import { MauiQueryClientProvider } from '@maui/react-query'
import { Provider as GtiProvider } from '@maui/app-gti'
import {
  ConfiguredMatiApiClientProvider as MatiApiClientProvider,
} from '@nautilusjs/app-mati-apis'

import { AuthProvider } from './AuthProvider'
import { RootContextProvider } from './RootContextProvider'
import { PagesContextProvider } from './PagesContextProvider'

export const MauiProvider = ({
  auth,
  children,
  queryClient,
}) => {
  return (
    <AuthProvider {...auth}>
      <MauiQueryClientProvider {...queryClient}>
        <MatiApiClientProvider>
          <MauiMfSplitFactory>
            <ExperimentsProvider>
              <GtiProvider>
                <RootContextProvider>
                  <PagesContextProvider>
                    {children}
                  </PagesContextProvider>
                </RootContextProvider>
              </GtiProvider>
            </ExperimentsProvider>
          </MauiMfSplitFactory>
        </MatiApiClientProvider>
      </MauiQueryClientProvider>
    </AuthProvider>
  )
}

MauiProvider.defaultProps = {
  queryClient: {},
  auth: {},
}

MauiProvider.propTypes = {
  auth: PropTypes.object,
  queryClient: PropTypes.object,
  children: PropTypes.node,
}
